import React, { FunctionComponent, ReactNode, useEffect, useRef } from 'react';
import { queryProcedureResult } from 'iguazu-rpc';
import { connectAsync, LoadDataAsPropsParams } from 'iguazu';
import { compose } from 'redux';
import { ReadProfileResponse } from '../types';

type Props = {
  children: ReactNode | ReactNode[];
};

type IguazuProps = {
  userProfile: ReadProfileResponse;
};
const ContentSquareScript = ({ children, userProfile }: Props & IguazuProps) => {
  // eslint-disable-next-line no-underscore-dangle -- This is what Content Square sets to be able to set these values
  const contentSquare = window?._uxa;
  const hasSetIdentity = useRef(false);

  useEffect(() => {
    if (
      global.BROWSER &&
      contentSquare &&
      userProfile?.data &&
      'supplierExperienceUserId' in userProfile.data &&
      !hasSetIdentity.current
    ) {
      contentSquare.push([
        'trackDynamicVariable',
        { key: 'supplierExperienceId', value: userProfile.data.supplierExperienceUserId },
      ]);
      hasSetIdentity.current = true;
    }
  }, [userProfile, contentSquare, hasSetIdentity]);

  return <div>{children}</div>;
};

export const loadDataAsProps = ({ store: { dispatch } }: LoadDataAsPropsParams<object>) => ({
  userProfile: () =>
    dispatch(
      queryProcedureResult<object, ReadProfileResponse>({
        procedureName: 'readSupplierExperienceUserProfileV1',
        args: {},
      })
    ),
});

const hocChain = compose<FunctionComponent<Props>>(connectAsync({ loadDataAsProps }));

export const TestableContentSquareIdentityWrapper = ContentSquareScript;
export default hocChain(ContentSquareScript);
